import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import GiftCardPageViewModel from './GiftCardPageViewModel.type';

type GiftCardPageType = GiftCardPageViewModel & PageType;

export default (currentPage: PageType): currentPage is GiftCardPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_GiftCards_GiftCardPageViewModel;
};
